module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av719-2cec6ae789b3dd6cb0c6deacf2d2e421.jpg";